import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngrx/store';

import {ProgrammingEventService, DeviceCategoryService} from '../services';

@Pipe({
  name: 'categoryItems'
})
export class CategoryItemsPipe implements PipeTransform {

  constructor(
    private deviceCategories: DeviceCategoryService,
    private store: Store<any>
  ) { }

  transform(items: any, category: string): Array<any> {
    if (category) {
      return items.filter(item => {
        let devcat = this.deviceCategories.getItemCategory(item);
        return (devcat === category);
      });
    } else {
      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/category-items.pipe.ts